export const instantPaymentModalConfig = {
  name: 'instant-payment',
  pageUrl:
    'https://cashier.wixapps.net/_serverless/payments-checkout-server/instant-payment',
  // we use such high number to enter full screen mode
  // https://wix.slack.com/archives/CAKBA7TDH/p1604926273350300?thread_ts=1604922926.343800&cid=CAKBA7TDH
  size: 5000,
  maxReadyTimeout: 10000,
};
